// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.selectDevices-sub-heading {
  font-size: 18px;
}

.selectDevices-heading {
  font-size: 30px;
  padding-top: 10px;
  margin-bottom: 10px;
  font-family: "ATT Aleck Sans";
}

.seachbox-heading {
  text-align: center;
  margin-top: 15px;
}

#button-section {
  padding-bottom: 20px;
}

.continue-btn {
  width: 171px;
  margin-left: 19px;
}

.selectDevices-greybox {
  background: linear-gradient(#F1F2F3, #F1F2F3);
  margin-right: auto;
  margin-left: auto;
  height: auto;
  margin-bottom: 20px;
  width: auto;
  float: left;
}

.color-square {
  border-radius: 2px;
  display: inline-block;
  height: 14px;
  margin-right: 10px;
  vertical-align: middle;
  width: 14px;
}

.custumgrid-field {
  display: inline-block;
  vertical-align: middle;
}

.gridText {
  display: inline-flex;
}

.custumgrid-field-status {
  vertical-align: super;
  line-height: 16px;
}

.seachbox-heading {
  text-align: left;
  font-family: "ATT Aleck Sans";
  letter-spacing: 0.67px;
  color: #191919;
  opacity: 1;
  height: 36px;
  font-size: 24px;
}

.container-box-sm {
  padding: 27px 20px 25px 20px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  max-width: 1250px;
}
.container-box-sm .input-field {
  width: 260px;
  height: 36px;
}
.container-box-sm .dropDownInput {
  width: 260px;
  height: 36px;
}
.container-box-sm .search-btn {
  width: 260px;
  height: 42px;
  margin-top: 15px;
  margin-left: 15px;
}
.container-box-sm .input-row {
  height: 70px;
}

.inputContent {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.clear-btn {
  height: 21px;
  text-align: right;
  padding-top: 1px;
  font: 16px ATT Aleck Sans;
  letter-spacing: 0.44px;
  color: #0568AE;
  opacity: 1;
}

.flex-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: stretch;
  align-items: center;
}

.search-placeholder {
  min-height: 100px;
  width: 364px;
  flex: 1 0 auto;
  align-self: stretch;
}

.filter-fields {
  padding: 0;
  margin: 0;
  padding: 20px;
  margin-right: 10px;
  margin-left: 10px;
}
.filter-fields a {
  padding: 0;
}
.filter-fields .alert-icon-ibm {
  width: 20px;
  float: left;
  margin-right: 10px;
}
.filter-fields .extra-content-ibm {
  float: left;
  width: 88%;
}
.filter-fields .icon-alert {
  width: 20px;
  height: 20px;
}

.checkboxgrid {
  width: 50px;
}

.wireless-col {
  width: 160px;
}

.wireless-col-grp {
  width: 113px;
}

.fieldset-extended {
  border: none;
}

.claimed-samsung {
  background-color: #035527;
}

.claimed-android™ {
  background-color: #035527;
}

.claimed-android {
  background-color: #035527;
}

.claimed-apple {
  background-color: #035527;
}

.claim-pending-samsung {
  background-color: #6BA179;
}

.claim-pending-android™ {
  background-color: #6BA179;
}

.claim-pending-android {
  background-color: #6BA179;
}

.claim-pending-apple {
  background-color: #6BA179;
}

.claim-pending {
  background-color: #6BA179;
}

.unclaim-pending-samsung {
  background-color: #9B8E82;
}

.unclaim-pending-android™ {
  background-color: #9B8E82;
}

.unclaim-pending-android {
  background-color: #9B8E82;
}

.unclaim-pending-apple {
  background-color: #9B8E82;
}

.unclaim-pending {
  background-color: #9B8E82;
}

.not-claimed {
  background-color: #e57200;
}

.not-claimed {
  background-color: #e57200;
}

.claim-initiated {
  background-color: #e97400;
}

.ctn-number {
  color: #191919;
  margin: 10px 0;
  cursor: default;
}

.username {
  margin-bottom: 10px !important;
  margin-top: 10px !important;
}

.claim-initiated {
  background-color: #e97400;
}

@media only screen and (max-width: 820px) {
  .dropdown-tm {
    margin-top: 45px !important;
    margin-bottom: 45px !important;
  }
}
@media only screen and (max-width: 768px) {
  .btn-width {
    margin: 0;
    width: 100%;
  }
}

.table {
  margin-left: -10px;
}
.table tr, .table th, .table td {
  border: 0;
}

@media only screen and (max-width: 540px) {
  .wireless-align {
    width: 70% !important;
  }
  .wireless-col {
    width: 100% !important;
    float: left !important;
  }
  .wireless-col-grp {
    width: 100% !important;
  }
  .custumgrid-field {
    float: left !important;
    padding-left: 7px;
  }
  .hiddenswitch div:nth-child(2) {
    float: left !important;
  }
  .status-cols {
    width: 100% !important;
  }
}
@media (max-width: 1024px) {
  .selectDropdown {
    margin-top: -20px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/grouping-devices/select-devices/select-devices.component.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACwBZ;EA4BA;IACE,YClDE;EFCN;ECgDE;IACE,aClDE;EFIN;EC6CE;IACE,UClDE;EFON;EC0CE;IACE,aClDE;EFUN;ECuCE;IACE,aClDE;EFaN;ECoCE;IACE,UClDE;EFgBN;ECiCE;IACE,aClDE;EFmBN;EC8BE;IACE,aClDE;EFsBN;EC2BE;IACE,UClDE;EFyBN;ECwBE;IACE,aClDE;EF4BN;ECqBE;IACE,aClDE;EF+BN;ECkBE;IACE,WClDE;EFkCN;ECoBE;IACE,kBCvDE;EFqCN;ECiBE;IACE,mBCvDE;EFwCN;ECcE;IACE,gBCvDE;EF2CN;ECWE;IACE,mBCvDE;EF8CN;ECQE;IACE,mBCvDE;EFiDN;ECKE;IACE,gBCvDE;EFoDN;ECEE;IACE,mBCvDE;EFuDN;ECDE;IACE,mBCvDE;EF0DN;ECJE;IACE,gBCvDE;EF6DN;ECPE;IACE,mBCvDE;EFgEN;ECVE;IACE,mBCvDE;EFmEN;ECbE;IACE,iBCvDE;EFsEN;AACF;AC9CI;EAoCA;IACE,YC9DE;EF2EN;ECdE;IACE,aC9DE;EF8EN;ECjBE;IACE,UC9DE;EFiFN;ECpBE;IACE,aC9DE;EFoFN;ECvBE;IACE,aC9DE;EFuFN;EC1BE;IACE,UC9DE;EF0FN;EC7BE;IACE,aC9DE;EF6FN;EChCE;IACE,aC9DE;EFgGN;ECnCE;IACE,UC9DE;EFmGN;ECtCE;IACE,aC9DE;EFsGN;ECzCE;IACE,aC9DE;EFyGN;EC5CE;IACE,WC9DE;EF4GN;EC1CE;IACE,kBCnEE;EF+GN;EC7CE;IACE,mBCnEE;EFkHN;EChDE;IACE,gBCnEE;EFqHN;ECnDE;IACE,mBCnEE;EFwHN;ECtDE;IACE,mBCnEE;EF2HN;ECzDE;IACE,gBCnEE;EF8HN;EC5DE;IACE,mBCnEE;EFiIN;EC/DE;IACE,mBCnEE;EFoIN;EClEE;IACE,gBCnEE;EFuIN;ECrEE;IACE,mBCnEE;EF0IN;ECxEE;IACE,mBCnEE;EF6IN;EC3EE;IACE,iBCnEE;EFgJN;AACF;AAjJA;EACE,eAAA;AAmJF;;AAhJA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BAAA;AAmJF;;AAhJC;EACC,kBAAA;EACA,gBAAA;AAmJF;;AAhJC;EACC,oBAAA;AAmJF;;AAhJC;EACC,YAAA;EACA,iBAAA;AAmJF;;AAhJA;EAEI,6CAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;AAkJJ;;AA/IA;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AAkJF;;AA/IA;EAEE,qBAAA;EACA,sBAAA;AAiJF;;AA9IC;EACC,oBAAA;AAiJF;;AA9IA;EAEE,qBAAA;EACA,iBAAA;AAgJF;;AA5IA;EACE,gBAAA;EACA,6BAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AA+IF;;AA5IA;EACE,4BAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AA+IF;AA7IE;EACE,YAAA;EACA,YAAA;AA+IJ;AA7IE;EACE,YAAA;EACA,YAAA;AA+IJ;AA7IE;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AA+IJ;AA7IE;EACE,YAAA;AA+IJ;;AA3IA;EACE,8BAAA;EACA,mBAAA;EACA,kBAAA;AA8IF;;AA1IA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;AA6IF;;AA1IA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AA6IJ;;AA1IA;EACI,iBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AA6IJ;;AA1IA;EACI,UAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;AA6IJ;AA5II;EACE,UAAA;AA8IN;AA3II;EACE,WAAA;EACA,WAAA;EACA,kBAAA;AA6IN;AA1II;EACE,WAAA;EACA,UAAA;AA4IN;AA1IE;EACE,WAAA;EACA,YAAA;AA4IJ;;AAvIA;EACE,WAAA;AA0IF;;AAvIA;EACE,YAAA;AA0IF;;AAvIA;EACE,YAAA;AA0IF;;AAvIA;EACE,YAAA;AA0IF;;AAvIA;EAEG,yBAAA;AAyIH;;AAtIC;EAEE,yBAAA;AAwIH;;AArIC;EAEE,yBAAA;AAuIH;;AApIC;EAEC,yBAAA;AAsIF;;AAlIA;EACE,yBAAA;AAqIF;;AAlIA;EACE,yBAAA;AAqIF;;AAlIA;EACE,yBAAA;AAqIF;;AAlIA;EACE,yBAAA;AAqIF;;AAlIA;EACE,yBAAA;AAqIF;;AAjIA;EACE,yBAAA;AAoIF;;AAjIA;EACE,yBAAA;AAoIF;;AAjIA;EACE,yBAAA;AAoIF;;AAjIA;EACE,yBAAA;AAoIF;;AAjIA;EACE,yBAAA;AAoIF;;AAhIC;EACE,yBAAA;AAmIH;;AAhIA;EACE,yBAAA;AAmIF;;AAhIA;EACE,yBAAA;AAmIF;;AAhIA;EACE,cAAA;EACA,cAAA;EACA,eAAA;AAmIF;;AAhIA;EACE,8BAAA;EACA,2BAAA;AAmIF;;AAjIC;EACE,yBAAA;AAoIH;;AAjIC;EACC;IACE,2BAAA;IACA,8BAAA;EAoIF;AACF;AAhIE;EADD;IAEE,SAAA;IACA,WAAA;EAmID;AACF;;AAhIC;EACC,kBAAA;AAmIF;AAlIE;EACE,SAAA;AAoIJ;;AAhIA;EACE;IACI,qBAAA;EAmIJ;EAhIA;IACE,sBAAA;IACA,sBAAA;EAkIF;EA/HA;IACE,sBAAA;EAiIF;EA9HA;IACE,sBAAA;IACA,iBAAA;EAgIF;EA7HA;IACE,sBAAA;EA+HF;EA5HA;IACE,sBAAA;EA8HF;AACF;AA1HA;EACE;IACE,4BAAA;EA4HF;AACF","sourcesContent":["@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n\n.selectDevices-sub-heading{\n  font-size: 18px;\n }\n \n.selectDevices-heading{\n  font-size: 30px;\n  padding-top: 10px;\n  margin-bottom: 10px;\n  font-family: 'ATT Aleck Sans';\n }\n\n .seachbox-heading{\n  text-align: center;\n  margin-top: 15px;\n}\n\n #button-section{\n  padding-bottom: 20px;\n }\n\n .continue-btn{\n  width: 171px;\n  margin-left: 19px;\n }\n\n.selectDevices-greybox{\n    //background: linear-gradient( rgba(216, 213, 213, 0.5), rgba(216, 213, 213, 0.5) );\n    background: linear-gradient( #F1F2F3,#F1F2F3 );\n    margin-right: auto;\n    margin-left: auto;\n    height: auto;\n    margin-bottom: 20px;\n    width: auto;\n    float: left;\n}\n\n.color-square {\n  border-radius: 2px;\n  display: inline-block;\n  height: 14px;\n  margin-right: 10px;\n  vertical-align: middle;\n  width: 14px;\n}\n\n.custumgrid-field {\n  //margin: 0 0 24px 0;\n  display: inline-block;\n  vertical-align: middle;\n }\n\n .gridText{\n  display:inline-flex\n}\n\n.custumgrid-field-status{\n  // margin: 0 0 11px 0;\n  vertical-align: super;\n  line-height: 16px;\n }\n \n\n.seachbox-heading{\n  text-align: left;\n  font-family: 'ATT Aleck Sans';\n  letter-spacing: 0.67px;\n  color: #191919;\n  opacity: 1;\n  height: 36px;\n  font-size: 24px;\n}\n\n.container-box-sm {\n  padding: 27px 20px 25px 20px;\n  height: auto;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1250px;\n\n  .input-field{\n    width: 260px;\n    height: 36px;\n  }\n  .dropDownInput{\n    width: 260px;\n    height: 36px;\n  }\n  .search-btn{\n    width: 260px;\n    height: 42px;\n    margin-top: 15px;\n    margin-left: 15px;\n  }\n  .input-row{\n    height: 70px;\n  }\n}\n\n.inputContent {\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n\n.clear-btn{\n  height: 21px;\n  text-align: right;\n  padding-top: 1px;\n  font: 16px ATT Aleck Sans;\n  letter-spacing: 0.44px;\n  color: #0568AE;\n  opacity: 1;\n}\n\n.flex-row {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-content: stretch;\n    align-items: center;\n}\n  \n.search-placeholder {\n    min-height: 100px;\n    width: 364px;\n    flex: 1 0 auto;\n    align-self: stretch;\n}\n\n.filter-fields{\n    padding: 0;\n    margin: 0;\n    padding: 20px;\n    margin-right: 10px;\n    margin-left: 10px;\n    a {\n      padding: 0;\n    }\n \n    .alert-icon-ibm {\n      width: 20px;\n      float: left;\n      margin-right: 10px;\n    }\n \n    .extra-content-ibm {\n      float: left;\n      width: 88%;\n  }\n  .icon-alert {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n\n.checkboxgrid{\n  width: 50px;\n}\n\n.wireless-col{\n  width: 160px;\n}\n\n.wireless-col-grp{\n  width: 113px;\n}\n\n.fieldset-extended {\n  border: none;\n}\n\n.claimed-samsung {\n  //  background-color: color(enrolledActive);\n   background-color: #035527;\n }\n \n .claimed-android™ {\n  //  background-color: color(enrolledActive);\n   background-color: #035527;\n }\n\n .claimed-android {\n  //  background-color: color(enrolledActive);\n   background-color: #035527;\n }\n \n .claimed-apple {\n  // background-color: color(enrolledActive);\n  background-color: #035527;\n\n}\n\n.claim-pending-samsung{\n  background-color: #6BA179;\n\n}\n.claim-pending-android™{\n  background-color: #6BA179;\n\n}\n.claim-pending-android{\n  background-color: #6BA179;\n\n}\n.claim-pending-apple{\n  background-color: #6BA179;\n\n}\n.claim-pending{\n  background-color: #6BA179;\n\n}\n\n.unclaim-pending-samsung{\n  background-color: #9B8E82;\n\n}\n.unclaim-pending-android™{\n  background-color: #9B8E82;\n\n}\n.unclaim-pending-android{\n  background-color: #9B8E82;\n\n}\n.unclaim-pending-apple{\n  background-color: #9B8E82;\n\n}\n.unclaim-pending{\n  background-color: #9B8E82;\n\n}\n \n .not-claimed {\n   background-color: #e57200;\n }\n\n.not-claimed {\n  background-color: #e57200;\n}\n\n.claim-initiated {\n  background-color: #e97400;\n}\n\n.ctn-number {\n  color: #191919;\n  margin: 10px 0;\n  cursor: default;\n}\n\n.username{\n  margin-bottom: 10px !important;\n  margin-top: 10px !important;\n}\n .claim-initiated {\n   background-color: #e97400;\n }\n\n @media only screen and (max-width: 820px) {\n  .dropdown-tm{\n    margin-top: 45px !important;\n    margin-bottom: 45px !important;\n  }\n }\n\n .btn-width{\n  @media only screen and (max-width: 768px){\n   margin:0;\n   width:100%;\n   }\n \n }\n .table {\n  margin-left: -10px;\n  tr,th,td {\n    border:0 ;\n  } \n}\n\n@media only screen and (max-width: 540px){\n  .wireless-align{\n      width:70% !important;\n  }\n\n  .wireless-col{\n    width:100% !important;\n    float: left !important;\n  }\n\n  .wireless-col-grp{\n    width: 100% !important;\n  }\n\n  .custumgrid-field{\n    float: left !important;\n    padding-left: 7px;\n  }\n\n  .hiddenswitch div:nth-child(2){\n    float: left !important;\n  }\n\n  .status-cols{\n    width: 100% !important;\n  }\n\n}\n\n@media (max-width: 1024px) {\n  .selectDropdown {\n    margin-top: -20px !important;\n  }\n}","@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
